module.exports = __webpack_public_path__ + "img/lung-cancer-leaflet.e6f9d73c.jpg";